(function() {
  'use strict';

  function centerActiveBullet(paginationContainer, activeBullet) {
    if (!paginationContainer || !activeBullet) return;

    const containerRect = paginationContainer.getBoundingClientRect();
    const bulletRect = activeBullet.getBoundingClientRect();
    const containerScrollLeft = paginationContainer.scrollLeft;
    
    const containerCenter = containerRect.width / 2;
    
    const bulletLeft = bulletRect.left - containerRect.left + containerScrollLeft;
    const bulletWidth = bulletRect.width;
    const bulletCenter = bulletLeft + (bulletWidth / 2);
    
    const scrollTarget = bulletCenter - containerCenter;
    
    paginationContainer.scrollTo({
      left: scrollTarget,
      behavior: 'smooth'
    });
  }

  function initPaginationScroll(swiperInstance) {
    if (!swiperInstance || !swiperInstance.pagination) return;

    const paginationEl = swiperInstance.pagination.el;
    if (!paginationEl || !paginationEl.classList.contains('swiper-pagination__featured-collection')) {
      return;
    }

    if (paginationEl.dataset.scrollInitialized === 'true') {
      return;
    }
    paginationEl.dataset.scrollInitialized = 'true';

    swiperInstance.on('slideChange', function() {
      setTimeout(function() {
        const activeBullet = paginationEl.querySelector('.swiper-pagination-bullet-active');
        if (activeBullet) {
          centerActiveBullet(paginationEl, activeBullet);
        }
      }, 50);
    });

    paginationEl.addEventListener('click', function(e) {
      if (e.target.classList.contains('swiper-pagination-bullet')) {
        setTimeout(function() {
          const activeBullet = paginationEl.querySelector('.swiper-pagination-bullet-active');
          if (activeBullet) {
            centerActiveBullet(paginationEl, activeBullet);
          }
        }, 50);
      }
    });

    setTimeout(function() {
      const activeBullet = paginationEl.querySelector('.swiper-pagination-bullet-active');
      if (activeBullet) {
        centerActiveBullet(paginationEl, activeBullet);
      }
    }, 100);
  }

  window.initSwiperPaginationScroll = function(swiperInstance) {
    initPaginationScroll(swiperInstance);
  };

  function autoInit() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', autoInit);
      return;
    }

    const paginationContainers = document.querySelectorAll('.swiper-pagination__featured-collection');
    
    paginationContainers.forEach(function(container) {
      const swiperElement = container.closest('.swiper') || 
                           container.parentElement?.querySelector('.swiper');
      
      if (swiperElement && swiperElement.swiper) {
        initPaginationScroll(swiperElement.swiper);
      }
    });
  }
  
  autoInit();

  if (window.MutationObserver) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            const paginationContainers = node.querySelectorAll 
              ? node.querySelectorAll('.swiper-pagination__featured-collection')
              : [];
            
            paginationContainers.forEach(function(container) {
              const swiperElement = container.closest('.swiper') || 
                                   container.parentElement?.querySelector('.swiper');
              
              if (swiperElement && swiperElement.swiper) {
                initPaginationScroll(swiperElement.swiper);
              }
            });
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();

